import { FC } from "react";
import styled from "styled-components";
import { CountryOptionResource } from "../types/country";

const AddressWrapper = styled.address`
	display: flex;
	flex-direction: column;
	font-style: inherit;
`;

interface Address {
	city: string;
	zip: string;
	houseNumber: string;
	street: string;
	additionalInfo: string | null;
	country: CountryOptionResource | null;
}

interface Props {
	address: Address;
}

export const Address: FC<Props> = ({ address }) => {
	return (
		<AddressWrapper>
			{address.additionalInfo && <span>{address.additionalInfo}</span>}
			<span>
				{address.street} {address.houseNumber}
			</span>
			<span>
				{address.zip} {address.city}
			</span>
			<span>{address.country?.name || "-"}</span>
		</AddressWrapper>
	);
};
